<template>
  <div class="formCom">
    <div class="form">
      <button class="close" @click="closeModal">
        <CloseIcone></CloseIcone>
      </button>
      <div class="txt" v-if="comment.comment !== ''">
        {{ comment.comment }}
      </div>
      <div class="txt" v-else>
        No Comments
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcone from "../../images/shared/cancel";

export default {
  name: "ActivateNewKit",
  props: ["comment"],
  methods: {
    closeModal() {
      this.$emit("closeCommentModal", false);
    }
  },
  components: {
    CloseIcone
  }
};
</script>

<style scoped>
.formCom {
  background-color: rgba(219, 230, 241, 0.5);
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}
.form {
  padding: 30px;
  background-color: #fff;
  max-width: 700px;
  width: 100%;
  position: relative;
}
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  border: 1px solid transparent;
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
}
.txt {
  text-align: center;
  font-size: 14px;
  font-family: TTNormsRegular, sans-serif;
  color: #808080;
}
</style>
